<!-- Иконка отсутствия телеметрии в истории маршрутов. -->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12" cy="12" r="10" :stroke="stroke" stroke-width="1.5" />
    <path d="M12 8V12M12 16H12.01" :stroke="stroke" stroke-width="1.5" />
  </svg>
</template>

<script>
export default {
  name: "CalendarHistoryWarningIcon",

  props: {
    size: { type: [Number, String], default: 20 },
    stroke: { type: String, default: "currentColor" },
  },
};
</script>
